import { PatientCooperationPartnerId } from '@app/icare/entities/patient/schema/PatientCooperationPartner'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientCooperationPartnerOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_cooperationPartner/-components/PatientCooperationPartnerOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner/$relation')({
  params: entityParams({ id: PatientId, relation: PatientCooperationPartnerId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientCooperationPartnerOverview patientId={id} relationId={relation} />
}
